import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function SmileViewSection() {
  return <section className="py-32 bg-weiss relative overflow-hidden" data-id="element-187">
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="bg-weiss p-12 md:p-20 border-2 border-transparent animated-gold-border" data-id="element-189">
          <motion.div animate={{
          rotate: [0, 10, -10, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="inline-block mb-8 relative" data-id="element-190">
            {/* Subtle Gold Glow behind Icon */}
            <div className="absolute inset-0 bg-gold/20 blur-xl rounded-full scale-150" data-id="element-191" />
            <SparklesIcon className="w-12 h-12 text-gold relative z-10" data-id="element-192" />
          </motion.div>

          <h2 className="text-4xl md:text-5xl font-poppins font-bold text-schwarz mb-6 uppercase tracking-tight" data-id="element-193">
            Traumlächeln auf Knopfdruck
          </h2>

          <p className="text-lg text-gray-medium font-lora mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-194">
            Sind Sie unzufrieden mit Ihrem Zahnstand und hätten Sie gerne ein
            neues und aussagekräftigeres Lächeln? Dann scannen Sie den Code oder
            benutzen Sie unseren Link und machen ein Selfie, um Ihr SmileView
            Abenteuer zu beginnen.
          </p>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-schwarz text-weiss px-10 py-4 font-poppins font-bold uppercase tracking-widest hover:bg-gold hover:text-schwarz transition-colors duration-300" data-id="element-195">
            Jetzt ausprobieren
          </motion.button>
        </motion.div>
      </div>
    </section>;
}